import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { PdvService } from '@app/services/pdv/pdv.service';
import { ChangeDetectorRef } from '@angular/core';
@Component({
    selector: 'app-command',
    templateUrl: 'command.component.html',
    styleUrls: ['command.component.scss']
})
export class CommandComponent implements OnInit {
    displayBestOffers = false;
    displayBestSales = false;
    siteClose: boolean = false;
    // alert=false;
    alerttop=150;
    siteCloseComment="";
    // @ViewChild('alertblock') alertblock:ElementRef
    @ViewChild('closeblock') closeblock:ElementRef
    // closealert=false;
    constructor(private pdvService: PdvService,private cdRef:ChangeDetectorRef) {}
    ngOnInit(): void {
        this.pdvService.pdv.subscribe(
            (pdv: any) => {
                if (pdv) {
                    this.displayBestSales = pdv.displayBestSales;
                    this.displayBestOffers = pdv.displayBestOffers;
                    this.siteClose=pdv.closeSite;
                    this.siteCloseComment=pdv.closeComment;
                    // this.alert=pdv.alert;
                }
            }
        )
    }
    ngAfterViewInit(){
        // if(this.alertblock && this.alert){
        //     this.alerttop= this.alerttop+Number(this.alertblock.nativeElement.clientHeight);
        // }
        if(this.closeblock && this.siteClose){
            this.alerttop= this.alerttop-20;
        }
        this.cdRef.detectChanges();
    }
}
